/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-09 14:39:43
 * @LastEditors: caiqin.xie
 * @message: 搜索结果-搜索组件
 */
import React from "react";
import { Input } from '@arco-design/web-react';
import { IconSearch } from '@arco-design/web-react/icon';
import styles from "../../index.module.scss";

interface IProps {
  ctry: string;
  words: Record<string, string>;
  keyword: string; // 搜索关键字
  searchBlog: () => void; // 搜索博客
  setkeyword: (keyword: string) => void; // 设置搜索关键字
}

const SearchInput = (props:IProps) => {
  const {ctry, words, keyword, setkeyword} = props

  // 设置搜索关键字
  const setkeywordHandler = (keyword:string) => {
    setkeyword(keyword)
  }

  // 搜索博客
  const searchBlogHandler = () => {
    // searchBlog()
    window.open(`/${ctry}/blog/search?keyword=${keyword}`, '_self')
  }

  return (
    <>
      <div className={styles["search-input"]}>
        <Input
          prefix={<IconSearch />}
          size="large"
          placeholder={words?.blog_search_placeholder}
          value={keyword.trim()}
          onChange={(value: string) => setkeywordHandler(value)}
          onPressEnter={searchBlogHandler} />
          {/* Search */}
      </div>
    </>
  )
}
export default SearchInput
